import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';

import { slideToRight, delayedAnimation } from './shared';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 289px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    min-height: 310px;
    max-width: 400px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    min-height: 356px;
    max-width: 100%;
  }
`;

const BaseImage = styled.div`
  position: absolute;
  top: 0;
  right: 100%;
  margin-right: 15px;

  background-image: url('/images/landing/eventExample/lounge-main-speaker.png');
  background-repeat: no-repeat;
  background-position: center center;

  width: 320px;
  height: 248px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    width: 359px;
    height: 278px;

    margin-right: 25px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    width: 465px;
    height: 260px;

    margin-right: 66px;
  }
`;

const Speaker = styled.img`
  position: absolute;
  top: 236px;
  right: 100%;
  margin-right: 237px;

  width: 91px;
  height: 53px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    top: 257px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 200px;
    width: 140px;
    height: 74px;

    margin-right: 370px;
  }
`;

const speaker2style = css`
  margin-right: 138px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    margin-right: 214px;
  }
`;

const Card = styled.img`
  position: absolute;
  top: 120px;
  right: 100%;
  width: 130px;
  height: 169px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    top: 141px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 98px;
    width: 198px;
    height: 258px;
  }
`;

export const Lounge = () => {
  return (
    <Wrapper>
      <BaseImage css={slideToRight} />
      <Speaker
        css={[slideToRight, delayedAnimation(0.7)]}
        src="/images/landing/eventExample/lounge-speaker-2.png"
        alt="speaker 2"
      />
      <Speaker
        css={[speaker2style, slideToRight, delayedAnimation(1.1)]}
        src="/images/landing/eventExample/lounge-speaker-3.png"
        alt="speaker 3"
      />
      <Card
        css={[slideToRight, delayedAnimation(1.5)]}
        src="/images/landing/eventExample/lounge-scio-card.png"
        alt="scio card"
      />
    </Wrapper>
  );
};
